import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, Company, EmployeeCode, UserCode } from '../../../utils/users';
import { GetLanguage } from '../../../utils/language';
import { errorResponse } from '../../../utils/response';
import { encryption } from '../../../utils/encryption';

export function scheduleScheduler(startDate, endDate) {
    let url = 'schedule/scheduler?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), startDate: startDate, endDate: endDate, language: GetLanguage(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let scheduler = response.scheduler;

                //saveConfig(scheduler);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getDescriptionHoursPayables() {
    let url = 'schedule/getDescriptionHoursPayables?' + objectToQueryString({ userCode: encryption(UserCode()), company: encryption(Company()), language: GetLanguage(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let result = response.result;

                //saveConfig(scheduler);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

function saveScheduler(config) {
    localStorage.setItem('scheduleScheduler', JSON.stringify(config));
}